import { useMemo } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { getSeoTitleForPath } from "./seoConstants";

export { HOME_TITLE, DEFAULT_TITLE } from "./seoConstants";

/**
 * Sets the document `<title>` from SEO config (≥30 chars for SERP).
 * Page-specific Helmet blocks may override on resource detail routes.
 */
const DocumentTitle = () => {
  const { pathname } = useLocation();
  const title = useMemo(() => getSeoTitleForPath(pathname), [pathname]);

  return (
    <Helmet key={pathname}>
      <title>{title}</title>
    </Helmet>
  );
};

export default DocumentTitle;
